import enquireJs from 'enquire.js'

export function isDef (v){
  return v !== undefined && v !== null
}

/**
 * Remove an item from an array.
 */
// eslint-disable-next-line consistent-return
export function remove (arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item)
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

export function isRegExp (v) {
  // eslint-disable-next-line no-use-before-define
  return _toString.call(v) === '[object RegExp]'
}

export function enquireScreen(call) {
  const handler = {
    match () {
      // eslint-disable-next-line no-unused-expressions
      call && call(true)
    },
    unmatch () {
      // eslint-disable-next-line no-unused-expressions
      call && call(false)
    }
  }
  enquireJs.register('only screen and (max-width: 767.99px)', handler)
}

// eslint-disable-next-line no-underscore-dangle
const _toString = Object.prototype.toString

// 转化对象为[{label:'Object.value',value:'Object.key'}]格式
export function formatData(data){
 return Object.keys(data).map(item=>{
    return {
      value:item,
      label:data[item]
    }
  })
}

// 检测对象的值只保留值为真的值
export function formatNullData(data){
  const obj={};
  Object.keys(data).forEach(item=>{
    if(data[item]){
      obj[item]=data[item]
    }
  })
  return obj;
}
// 过滤对象中不为真的属性
export function filterNull(data){
  const obj={}
  Object.keys(data).forEach(item=>{
    if(data[item]){
      obj[item]=data[item]
    }
  })
  return obj
}

// 处理替换session数据
export function handleCarrierData(){
  const {customerCode,customerId,customerName,tenantId,tenantName,creditCode}=JSON.parse(localStorage.getItem('vuex')).user
  if(!creditCode||(creditCode&&!customerCode)){
    return false
  }
  return {
    isConvertEnterprise:true,
    enterpriseCustomer:{
            carrierTenantId:tenantId,
            carrierTenantName:window.encodeURI(tenantName),
            customerId,
            customerCode,
            customerName:window.encodeURI(customerName),
           }
         }
}


export function evil(fn) {
  const Fn = Function;
  return new Fn(`return ${fn}`)();
}
// json数组去重
export function uniqueArray(array, key='value') {
  if (!array || !array.length) {
    return []
  }
  const result = [array[0]];
  for (let i = 1; i < array.length; i += 1) {
    const item = array[i];
    let repeat = false;
    for (let j = 0; j < result.length; j += 1) {
      if (item[key] === result[j][key]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
}

/**
 * 金额格式化
 * parameter：
 *     num：格式化目标数字
 *     decimal：保留几位小数，默认2位
 *     split：千分位分隔符，默认为,
 *     moneyFormat(123456789.87654321, 2, ',') // 123,456,789.88
 */
export const moneyFormat = (num, decimal = 2, split = ',') => {
  // eslint-disable-next-line no-shadow
  function thousandFormat (num) {
    const len = num.length
    return len <= 3 ? num : thousandFormat(num.substr(0, len - 3)) + split + num.substr(len - 3, 3)
  }
  // eslint-disable-next-line no-restricted-globals
  if (isFinite(num)) { // num是数字
    if (num === 0) { // 为0
      return num.toFixed(decimal)
    }  // 非0
      let res = ''
      const dotIndex = String(num).indexOf('.')
      if (dotIndex === -1) { // 整数
        res = `${thousandFormat(String(num))  }.${  '0'.repeat(decimal)}`
      } else { // 非整数
        // js四舍五入 Math.round()：正数时4舍5入，负数时5舍6入
        // Math.round(1.5) = 2
        // Math.round(-1.5) = -1
        // Math.round(-1.6) = -2
        // 保留decimals位小数
        // eslint-disable-next-line no-restricted-properties
        const numStr = String((Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal)).toFixed(decimal)) // 四舍五入，然后固定保留2位小数
        const decimals = numStr.slice(dotIndex, dotIndex + decimal + 1) // 截取小数位
        res = thousandFormat(numStr.slice(0, dotIndex)) + decimals
      }
      return res

  }
    return '--'

}



export function scrollToTarget(target) {
  function getElementToPageTop(el) { // 获取元素距离顶部距离
    if(el == null){
      return
    }
    // eslint-disable-next-line no-underscore-dangle
    // const _this = this;
    if(el.parentElement && el.offsetTop<200) {
      // eslint-disable-next-line consistent-return
      return getElementToPageTop(el.parentElement) + el.offsetTop
    }
    // eslint-disable-next-line consistent-return
    return el.offsetTop



  }
  const errDomList = document.querySelectorAll(target)
  const element = errDomList[0];

  if(element) {
    const test = getElementToPageTop(element)
    console.log('getElementToPageTop(element)', getElementToPageTop(element))
    document.querySelector("#popContainer").scrollTo({
      top: test,
      behavior: 'smooth'
    });
  }
}

export function scrollToTargetWareHourse() {
// 获取第一个错误元素
  const firstErrorElement = document.querySelector('.has-error');
  
// 定义函数以获取元素相对于页面的垂直偏移量
  function getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }

// 获取第一个错误元素相对于页面的垂直偏移量
  const offsetTop = getOffsetTop(firstErrorElement);

// 滚动页面到指定的垂直偏移量
  document.querySelector("#popContainer").scrollTo({
    top: offsetTop,
    behavior: 'smooth' // 可选，平滑滚动效果
  });
}

// 反转对象的健值
export function inverseObject(obj){
  const retobj = {};
  Object.keys(obj).forEach(key=>{
    retobj[obj[key]] = key;
  })
  return retobj;
}